import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import pickBy from 'lodash/pickBy';

import {revertLocationParamsConvertion} from 'app/store/sweet-api/utils';

import type {TemplateFetchParams, TemplateLocationParams} from './types';
import type {DefaultRootState} from 'react-redux';

interface DashboardState {
  filters: TemplateLocationParams;
}

const initialState: DashboardState = {
  filters: {} as TemplateLocationParams,
};

const templateSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    setTemplateFilters(state, action: PayloadAction<TemplateFetchParams>) {
      state.filters = revertLocationParamsConvertion(action.payload);
    },
  },
});

export const {setTemplateFilters} = templateSlice.actions;

export const selectTemplateFilters = (
  state: DefaultRootState
): TemplateLocationParams => pickBy(state.templates.filters);

export const templatesReducer = templateSlice.reducer;
